// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1b-q";
export var animationRelative = "_1b-p";
export var backdropBlur = "_1b-0";
export var detailLabelCell = "_1b-12";
export var detailTable = "_1b-11";
export var detailValueCell = "_1b-13";
export var docIconBox = "_1b-1d";
export var docIconBoxMd = "_1b-1f";
export var docIconBoxSm = "_1b-1e";
export var docTypeRow = "_1b-16";
export var docTypeRowInner = "_1b-17";
export var dropdownMatchDatePicker = "_1b-3";
export var evidenceCardContent = "_1b-1c";
export var fileUploadSpin = "_1b-j";
export var gorgiasOpenButton = "_1b-15 _1b-d";
export var gorgiasTicketCard = "_1b-14";
export var heroModalFooterButton = "_1b-18";
export var hiddenContainer = "_1b-o";
export var iconPrimary = "_1b-1g";
export var iconSecondary = "_1b-1h";
export var iconTertiary = "_1b-1i";
export var integrationCard = "_1b-1";
export var integrationLogoBox = "_1b-2";
export var mainColumnSticky = "_1b-1b";
export var maxWidthContainer = "_1b-19";
export var modalContentBody = "_1b-a";
export var modalHeaderImage = "_1b-5";
export var modalImageLabel = "_1b-7";
export var modalImageOverlay = "_1b-6";
export var modalImageSubtitle = "_1b-9";
export var modalImageTitle = "_1b-8";
export var modalImageWrapper = "_1b-4";
export var modalStickyFooter = "_1b-b";
export var removeButton = "_1b-e";
export var sidebarColumn = "_1b-1a";
export var spinner = "_1b-i";
export var timelineLine = "_1b-y";
export var timelineLineBlack = "_1b-10 _1b-y";
export var timelineLineGray = "_1b-z _1b-y";
export var timelineLineHeight = "_1b-x";
export var tlDotActivate = "_1b-u";
export var tlDotActivateAnim = "_1b-t";
export var tlDotHide = "_1b-s";
export var tlDotHideAnim = "_1b-r";
export var tlLineActivate = "_1b-w";
export var tlLineActivateAnim = "_1b-v";
export var uploadHint = "_1b-n";
export var uploadIconBox = "_1b-k";
export var uploadLabel = "_1b-m";
export var uploadText = "_1b-l";
export var uploadZone = "_1b-f";
export var uploadZoneCursorDefault = "_1b-h";
export var uploadZoneCursorPointer = "_1b-g";
export var uploadedFileRow = "_1b-c";
export var viewButton = "_1b-d";